module.exports = __webpack_public_path__ + "static/media/weather.7ca48b90.svg";